import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'TextContent',
})(({ spacing, breakpoints }) => ({
  content: {
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: spacing(2),
    width: '100%',
  },
  headline: {
    marginBottom: spacing(1),
  },
  body: {
    paddingRight: 0,
    [breakpoints.up('md')]: {
      paddingRight: spacing(5),
    },
  },
  ctaContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: spacing(1),
  },
  qrCodeContainer: {
    display: 'flex',
    gap: spacing(0),
  },
  appLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(-1),
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
